import store from '@/states/index.js'

import SupplierToBeQuoted from '../SupplierToBeQuoted.vue'

export default [
    {
        path: '/supplier_to_be_quoted',
        component: SupplierToBeQuoted,
        name: 'supplier_to_be_quoted',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 2){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]